import { css } from 'linaria';
import { styled } from 'linaria/react';
import { LinkWithGAClickButton } from 'common/components';

export const resultTextStyle = css`
  max-width: 740px;
  margin-bottom: 32px;

  @media (--to-desktop) {
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

export const Result = styled(LinkWithGAClickButton)`
  position: absolute;
  top: 78px;
  right: 0;
  display: flex;
  align-items: center;

  @media (--only-desktop) {
    top: 13px;
    flex-direction: column;
    align-items: flex-start;
    width: 125px;
  }

  @media (--to-desktop) {
    position: static;
    flex-direction: row;
    align-items: center;
    width: max-content;
  }

  @media (--only-tablet) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const ResultContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (--to-desktop) {
    order: 2;
  }
`;

export const DownloadResultImage = styled.img`
  width: 40px;
  height: 40px;

  @media (--only-largeDesktop) {
    margin-left: 8px;
  }

  @media (--only-desktop) {
    margin-bottom: 4px;
  }

  @media (--to-desktop) {
    margin-right: 8px;
  }
`;

export const dowloadResultText = css`
  margin-bottom: 2px;

  @media (--only-desktop) {
    margin-bottom: 4px;
  }
`;

export const resultSubtitleStyle = css`
  display: block;
  margin-bottom: 24px;

  @media (--to-desktop) {
    margin-bottom: 16px;
  }
`;

export const ResultImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
  border-radius: var(--rounding-l);
  box-shadow: var(--box-shadow-m);

  @media (--to-desktop) {
    margin-bottom: 16px;
  }

  @media (--only-tablet) {
    margin-bottom: 12px;
  }
`;

export const resultSection = css`
  position: relative;
`;

export const swiperStyle = css`
  && {
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 16px;

    @media (--from-tablet) {
      overflow: inherit;
    }

    @media (--only-mobile) {
      width: auto;
      padding-right: 16px;
      padding-left: 16px;
      margin-right: -16px;
      margin-left: -16px;
    }

    .swiper-wrapper {
      justify-content: flex-start;

      @media (--only-mobile) {
        margin-bottom: 14px;
      }
    }
  }
`;

export const swiperSlideStyle = css`
  && {
    width: 271px;
    margin-right: 32px;

    @media (--only-desktop) {
      width: 220px;
      margin-right: 20px;
    }

    @media (--only-tablet) {
      width: 156px;
      margin-right: 12px;
    }

    @media (--only-mobile) {
      width: 213px;
      margin-right: 24px;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const resultImageTextStyle = css`
  max-width: 202px;

  @media (--only-desktop) {
    max-width: 215px;
  }

  @media (--to-desktop) {
    max-width: 100%;
  }
`;
